<div class="admin-approvals">
  <!-- Header -->
  <div class="header">
    <div class="header-content">
      <div class="header-title">
        <svg class="header-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="m22 21-2-2"></path>
          <path d="M16 16h6"></path>
        </svg>
        <div>
          <h1>Approbations Utilisateurs</h1>
          <p>Gérer les demandes d'inscription en attente</p>
        </div>
      </div>
      <div class="header-stats">
        <div class="stat-card">
          <div class="stat-number">{{ getFilteredUsers().length }}</div>
          <div class="stat-label">En attente</div>
        </div>
        <div class="stat-card">
          <div class="stat-number">{{ getTodayCount() }}</div>
          <div class="stat-label">Aujourd'hui</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Controls -->
  <div class="controls">
    <div class="search-container">
      <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.35-4.35"></path>
      </svg>
      <input
        type="text"
        placeholder="Rechercher des utilisateurs..."
        [(ngModel)]="searchTerm"
        class="search-input"
      />
    </div>
    <div class="filter-container">
      <svg class="filter-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <polygon points="22,3 2,3 10,12.46 10,19 14,21 14,12.46"></polygon>
      </svg>
      <select
        [(ngModel)]="filterRole"
        class="filter-select"
      >
        <option value="ALL">Tous les rôles</option>
        <option value="USER">Utilisateurs</option>
        <option value="AGENT">Agents</option>
        <option value="ADMIN">Administrateurs</option>
      </select>
    </div>
    <button (click)="loadPendingApprovals()" class="refresh-btn" [disabled]="isLoading">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" [class.spinning]="isLoading">
        <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
        <path d="M21 3v5h-5"></path>
        <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
        <path d="M3 21v-5h5"></path>
      </svg>
    </button>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="error-message">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
    <span>{{ errorMessage }}</span>
    <button (click)="errorMessage = ''" class="error-close">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="loading-state">
    <svg class="loading-spinner" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
      <path d="M21 3v5h-5"></path>
      <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
      <path d="M3 21v-5h5"></path>
    </svg>
    <span>Chargement des demandes...</span>
  </div>

  <!-- Empty State -->
  <div *ngIf="!isLoading && pendingUsers.length === 0" class="empty-state">
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
      <polyline points="22,4 12,14.01 9,11"></polyline>
    </svg>
    <h3>Aucune demande en attente</h3>
    <p>Toutes les demandes d'utilisateurs ont été traitées</p>
  </div>

  <!-- No Results -->
  <div *ngIf="!isLoading && pendingUsers.length > 0 && getFilteredUsers().length === 0" class="empty-state">
    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="11" cy="11" r="8"></circle>
      <path d="m21 21-4.35-4.35"></path>
    </svg>
    <h3>Aucun résultat trouvé</h3>
    <p>Essayez d'ajuster vos critères de recherche</p>
  </div>

  <!-- User List -->
  <div *ngIf="!isLoading && getFilteredUsers().length > 0" class="user-list">
    <div class="list-header">
      <div class="list-title">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
        </svg>
        <span>Demandes en attente ({{ getFilteredUsers().length }})</span>
      </div>
    </div>
    
    <div class="user-items">
      <div *ngFor="let user of getFilteredUsers(); trackBy: trackByUserId" class="user-item">
        <div class="user-info">
          <div class="user-avatar">
            {{ getUserInitials(user.firstName, user.lastName) }}
          </div>
          <div class="user-details">
            <div class="user-name">{{ user.firstName }} {{ user.lastName }}</div>
            <div class="user-meta">
              <span class="username">{{ user.username }}</span>
              <span class="email">{{ user.email }}</span>
              <span class="date">{{ user.createdAt | date:'MMM d, y, h:mm a' }}</span>
            </div>
          </div>
        </div>
        
        <div class="user-role">
          <span class="role-badge" [class]="getRoleColorClass(user.role)">
            {{ getRoleDisplayName(user.role) }}
          </span>
        </div>

        <div class="user-actions">
          <button
            (click)="approveUser(user.id, user.role)"
            class="approve-btn"
            [disabled]="isLoading"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="20,6 9,17 4,12"></polyline>
            </svg>
            Approuver
          </button>
          <button
            (click)="rejectUser(user.id)"
            class="reject-btn"
            [disabled]="isLoading"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
            Rejeter
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
